import type DataQueryDefinitionFactory from './DataQueryDefinition';
import type { DataQueryColumnFactory } from './DataQueryColumn';

type InternalDataQuery = InstanceType<ReturnType<typeof DataQueryDefinitionFactory>>;
type InternalDataQueryColumn = InstanceType<ReturnType<typeof DataQueryColumnFactory>>;

export const enum ColumnAlignmentsEnum {
	Left = 0,
	Center = 1,
	Right = 2,
}

export type DataQueryColumn = InternalDataQueryColumn & {
	AttributeValueType: string; //enum MxObjectPropertyType
	Name: string;
	Title: string;
	ReferenceTo?: string;
	ReferenceFilter?: string;
	IsEnum: boolean;
	IsPickup: boolean;
	Format?: string;
	GroupingIsAvailable: boolean;
	Alignment: ColumnAlignmentsEnum;
	Expression: string;
	EntityClassName: string;
	// TBD
};

export type DataQuery = InternalDataQuery & {
	ServiceInfo?: {
		Name: string;
		Id: string;
	};
};
